import httpClient from '../utils/httpClient';
import toSnakeCase from '../utils/objectToSnakeCase';
import { getAuthToken } from '../utils/utils';

export const create = async patientData => {
	const { data, error } = await httpClient({
		method: 'post',
		url: `/patients`,
		data: toSnakeCase(patientData),
		headers: {
			authorization: getAuthToken()
		}
	});

	return { data, error };
};

export const patientExists = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/patients/${filter.contact_cellphone}/exists`,
		headers: {
			authorization: getAuthToken()
		}
	});

	return { data, error };
};

export const updateDocument = async (patientData, updateToken) => {
	const { data, error } = await httpClient({
		method: 'put',
		url: '/patients',
		data: toSnakeCase(patientData),
		headers: {
			authorization: `Bearer ${updateToken}`
		}
	});

	return { data, error }
};

export const createRegistration = async (patientData, registrationToken) => {
	const { data, error } = await httpClient({
		method: 'post',
		url: '/patients/registration',
		data: toSnakeCase(patientData),
		headers: {
			authorization: `Bearer ${registrationToken}`
		}
	});

	return { data, error };
};

export const findRegistration = async registrationToken => {
	const { data, error } = await httpClient({
		method: 'get',
		url: '/patients/registration',
		headers: {
			authorization: `Bearer ${registrationToken}`
		}
	});

	return { data, error };
};

export const updateRegistration = async (patientData, registrationToken) => {
	const { data, error } = await httpClient({
		method: 'put',
		url: '/patients/registration',
		data: toSnakeCase(patientData),
		headers: {
			authorization: `Bearer ${registrationToken}`
		}
	});

	return { data, error };
};

export const uploadInsuranceCardByRegistrationToken = async (file, registrationToken) => {
	const formData = new FormData();

	formData.append('file', file);

	const { data, error } = await httpClient({
		method: 'post',
		url: '/patients/registration/insurance-card',
		data: formData,
		headers: {
			authorization: `Bearer ${registrationToken}`
		}
	});

	return { data, error };
};

export const deleteInsuranceCardByRegistrationToken = async registrationToken => {
	const { data, error } = await httpClient({
		method: 'delete',
		url: '/patients/registration/insurance-card',
		headers: {
			authorization: `Bearer ${registrationToken}`
		}
	});

	return { data, error };
};
